import { Redirect, Route, RouteProps } from 'react-router-dom';
import { routers, userRouters } from './router';
import React from 'react';
import { identifyUserpilot } from 'utils/userpilotClient';
import { useAppSelector } from 'app/hooks';
import { getAccessToken, getIsConfirmedByPhone } from 'utils/sessionStorage';
import { getPersistedInviteToken, INVITE_TOKEN_QUERY } from 'utils/partnerInvite';
import { hasProgramAfterSignin, takeProgramAfterSignin } from 'utils/programRedirect';

const ProtectedRoute = (props: RouteProps) => {
  const token = getAccessToken();
  const information = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const stripeSubscription = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfo);
  const role  = information?.user_role ?? '';
  // const location = useLocation();
  React.useEffect(() => {
    if (token && information?.id) {
      identifyUserpilot(information?.student_id, role, {
        name: information?.first_name,
        email: information?.email,
        created_at: information?.created_at,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [information?.id]);

  if (!token) {
    return (
      <Redirect
        to={{
          pathname: userRouters.login.path,
          state: { from: props.location },
        }}
      />
    );
  }
  
  // Check if phone is confirmed - redirect to verify phone if not
  // Only check if we have user information (to allow login/register flow)
  const isConfirmedByPhone = getIsConfirmedByPhone();
  const isLoginOrRegisterPage = props.location?.pathname?.includes('/public/login') || 
                                props.location?.pathname?.includes('/public/register');
  
  if (token && !isConfirmedByPhone && !isLoginOrRegisterPage && information?.id) {
    const inviteTok = getPersistedInviteToken();
    const phoneSearch = inviteTok
      ? `?step=phone&${INVITE_TOKEN_QUERY}=${encodeURIComponent(inviteTok)}`
      : '?step=phone';
    return (
      <Redirect
        to={{
          pathname: userRouters.register.path,
          search: phoneSearch,
          state: { from: props.location },
        }}
      />
    );
  }
  
  if(token && stripeSubscription?.subcription_plan === '' && information?.user_role === 'student') {
    return (
      <Redirect
        to={{
          pathname: userRouters.payment.path,
          state: { from: props.location },
        }}
      />
    );
  } 
  else {
    // Signed up from a program page on www.gradmap.com: open that program once.
    if (token && information?.id && role === 'student' && hasProgramAfterSignin()) {
      const programId = takeProgramAfterSignin();
      if (programId && props.location?.pathname !== routers.summerProgramsDetail.path) {
        return <Redirect to={{ pathname: routers.summerProgramsDetail.path, search: `?id=${programId}` }} />;
      }
    }
    return (
      <>
        <Route {...props} />
      </>
    );
  }
};

export default ProtectedRoute;
